import { compileTokenGroup as o } from "./utils8.mjs";
import { FONT_WEIGHT_MAPPING as p } from "./constants29.mjs";
import { compileElevation as i } from "./compileElevation.mjs";
import { compilePalette as a } from "./compilePalette.mjs";
import { compileTypography as n } from "./compileTypography.mjs";
import { compileLineHeights as r } from "./compileLineHeights.mjs";
import { compileShadow as m } from "./compileShadow.mjs";
import { compileShadows as s } from "./compileShadows.mjs";
import { compileFocusRingShadows as c } from "./compileFocusRingShadows.mjs";
const l = () => o("fontSize", { addPx: !0 }), g = () => o("letterSpacing", { addPx: !0 }), d = () => o("fontWeights", { mappings: p }), v = (e) => {
  const t = {
    fontSize: l(),
    lineHeights: r(),
    letterSpacing: g(),
    fontWeights: d(),
    elevation: i(),
    fontFamilies: o("fontFamilies"),
    paragraphSpacing: o("paragraphSpacing"),
    textCase: o("textCase"),
    textDecoration: o("textDecoration"),
    spacing: o("spacing", { addPx: !0 }),
    radius: o("radius", { addPx: !0 }),
    paragraphIndent: o("paragraphIndent"),
    typography: {},
    shadow: m(),
    Elevation: i(),
    Shadows: s(),
    FocusRing: c()
  };
  return {
    dark: {
      palette: a(e, "dark")
    },
    light: {
      palette: a(e, "light")
    },
    tokens: {
      ...t,
      typography: n(t)
    }
  };
};
export {
  v as compileNovaTokens
};
//# sourceMappingURL=compileNovaTokens.mjs.map
